import { render, staticRenderFns } from "./ACcosmetics.vue?vue&type=template&id=4df6142f&scoped=true&"
import script from "./ACcosmetics.vue?vue&type=script&lang=js&"
export * from "./ACcosmetics.vue?vue&type=script&lang=js&"
import style0 from "./ACcosmetics.vue?vue&type=style&index=0&id=4df6142f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df6142f",
  null
  
)

export default component.exports